// components/Header.tsx
"use client";
import {useCallback, useState} from 'react'
import {
  Dialog,
  DialogPanel,
  PopoverGroup,
} from '@headlessui/react'
import {
  Bars3Icon,
  XMarkIcon,
} from '@heroicons/react/24/outline'
import { FaGithub, FaLinkedin } from "react-icons/fa";

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)


  const scrollToSection = useCallback((id: string) => {
    setMobileMenuOpen(false);
    setTimeout(() => {
      if (id === '') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  }, []);

  return (
    <header className="bg-black sticky top-0 z-50">
      <nav className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8" aria-label="Global">
        <div className="flex lg:flex-1">
        </div>
        <div className="flex lg:hidden">
          <button
            type="button"
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
            onClick={() => setMobileMenuOpen(true)}
          >
            <span className="sr-only">Open main menu</span>
            <Bars3Icon className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>
        <PopoverGroup className="hidden lg:flex lg:gap-x-12">
          <button
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="text-sm font-semibold leading-6 text-white hover:text-red-700/80"
          >
            Home
          </button>
          <button
              onClick={() => document.getElementById('projects-section')?.scrollIntoView({ behavior: 'smooth' })}
              className="text-sm font-semibold leading-6 text-white hover:text-red-700/80"
          >
            Projects
          </button>
          <button
              onClick={() => document.getElementById('about-me')?.scrollIntoView({ behavior: 'smooth' })}
              className="text-sm font-semibold leading-6 text-white hover:text-red-700/80"
          >
            About me
          </button>
          <button
              onClick={() => document.getElementById('contracts-section')?.scrollIntoView({ behavior: 'smooth' })}
              className="text-sm font-semibold leading-6 text-white hover:text-red-700/80"
          >
            Contracted Works
          </button>
          <button
              onClick={() => document.getElementById('contact-section')?.scrollIntoView({ behavior: 'smooth' })}
              className="text-sm font-semibold leading-6 text-white hover:text-red-700/80"
          >
            Contact
          </button>
          <button
              onClick={() => document.getElementById('academia-section')?.scrollIntoView({ behavior: 'smooth' })}
              className="text-sm font-semibold leading-6 text-white hover:text-red-700/80"
          >
              Academia & Research
          </button>
        </PopoverGroup>
          {/* Socials (desktop only) */}
          <div className="hidden lg:flex lg:ml-8 items-center gap-x-4">
              <a
                  href="https://github.com/tasnaps"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#F2F2F2] hover:text-red-700/80"
              >
                  <FaGithub className="h-5 w-5" />
              </a>
              <a
                  href="https://linkedin.com/in/tapio-meriläinen-20008810b/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#F2F2F2] hover:text-red-700/80"
              >
                  <FaLinkedin className="h-5 w-5" />
              </a>
          </div>

        <div className="hidden lg:flex lg:flex-1 lg:justify-end">
        </div>
      </nav>
      <Dialog className="lg:hidden" open={mobileMenuOpen} onClose={setMobileMenuOpen}>
        <div className="fixed inset-0 z-10" />
        <DialogPanel className="fixed inset-y-0 right-0 z-40 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
          <div className="flex items-center justify-between">
            <a href="#" className="-m-1.5 p-1.5">
              <span className="sr-only">Portfolio-TM</span>
            </a>
            <button
              type="button"
              className="-m-2.5 rounded-md p-2.5 text-gray-700"
              onClick={() => setMobileMenuOpen(false)}
            >
              <span className="sr-only">Close menu</span>
              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-500/10">
              <div className="space-y-2 py-6">
                <button
                    onClick={() => scrollToSection('')}
                    className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                >
                  Home
                </button>
                <button
                    onClick={() => scrollToSection('projects-section')}
                    className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                >
                  Projects
                </button>
                <button
                    onClick={() => scrollToSection('about-me')}
                    className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                >
                  About me
                </button>
                <button
                    onClick={() => scrollToSection('contracts-section')}
                    className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                >
                  Contracted Works
                </button>
                <button
                    onClick={() => scrollToSection('contact-section')}
                    className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                >
                  Contact
                </button>
                <button
                    onClick={() => scrollToSection('academia-section')}
                    className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                >
                  Academia & Research
                </button>
                  <div className="flex items-center gap-x-4 pt-6">
                      <button
                          onClick={() => {
                              setMobileMenuOpen(false);
                              window.open("https://github.com/tasnaps", "_blank");
                          }}
                          className="text-gray-700 hover:text-[#383F44]"
                      >
                          <FaGithub className="h-8 w-8" />
                      </button>
                      <button
                          onClick={() => {
                              setMobileMenuOpen(false);
                              window.open("https://linkedin.com/in/tapio-meriläinen-20008810b/", "_blank");
                          }}
                          className="text-gray-700 hover:text-[#383F44]"
                      >
                          <FaLinkedin className="h-8 w-8" />
                      </button>
                  </div>
              </div>
            </div>
          </div>
        </DialogPanel>
      </Dialog>
    </header>
  )
}
